import NameSpace from '../ns/NameSpace'
import DataManager from '../data/DataManager'

/**
 * PIXI.Application共通化クラス
 */
class MyApplication {

  // ---------------------------------------------------------------------------------------------------------
  // --	MyApplication
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor()
  {
  }

  /**
   * PIXI.Applicationの参照を取得
   */
  getMyApp()
  {
    if(!this.app)
    {
      //アプリケーション生成
      this.app = new PIXI.Application({
        resolution: 1,
        transparent: false
      })

      //zIndexで重ね順を変更できるようにする
      this.app.stage.sortableChildren = true

      //エミッター
      this.app.emitter = new PIXI.utils.EventEmitter()

      //DOMを配置
      document.getElementById('canvas-container').appendChild(this.app.view);

      //データマネージャーで保持
      DataManager.setData('app', this.app)
    }

    return this.app
  }

  // ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.core').MyApplication)
  NameSpace.getNameSpace('okawari.common.core').MyApplication = new MyApplication()
export default NameSpace.getNameSpace('okawari.common.core').MyApplication